import React, { useState, useEffect } from 'react';

import axios from 'axios';
import Progress from 'react-progress-2';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import CardHeader from '../../components/common/CardHeader';
import LinkButton from '../../components/common/LinkButton';
import CardBody from '../../components/common/CardBody';
import ProductImage from '../../components/common/ProductImage';
import EditButton from '../../components/common/EditButton';
import ViewButton from '../../components/common/ViewButton';
import DeleteButton from '../../components/common/DeleteButton';

const DepartingCityList = () => {
      const [loading, setLoading] = useState(false);
      const [cities, setCities] = useState([]);
      const [totalCities, setTotalCities] = useState(0);
      const [perPages, setPerPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);

      const token = JSON.parse(localStorage.getItem('token'));
      const [limit, setLimit] = useState(10);
      const [search, setSearch] = useState('');

      const loadData = async () => {
            setLoading(true);
            axios.get(
                  `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/departing_cities?limit=${limit}&search=${search}`,
                  {
                        headers: {
                              Authorization: `Bearer ${token}`
                        }
                  }
            )
                  .then((response) => {
                        setCities(response.data.cities);
                        setTotalCities(response.data.totalCities);
                        setPerPages(response.data.itemsCountPerPage);
                        setCurrentPage(response.data.currentPage);
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      useEffect(() => {
            loadData();
      }, [limit, search]);

      async function getData(pageNumber = 1) {
            window.scrollTo(0, 0);
            setLoading(true);
            Progress.show();
            const url = `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/departing_cities?page=${pageNumber}&limit=${limit}&search=${search}`;
            await axios(url, {
                  headers: {
                        Authorization: `Bearer ${token}`
                  }
            })
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setCities(response.data.cities);
                              setTotalCities(response.data.totalCities);
                              setPerPages(response.data.itemsCountPerPage);
                              setCurrentPage(response.data.currentPage);
                        }
                        Progress.hide();
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      }

      const handleStatus = async (category) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/departing_cities/${category.slug}/status`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleFeatured = async (category) => {
            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/departing_cities/${category.slug}/featured`,
                        {},
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                        }
                        if (response.data.result === 'error') {
                              toast.error(response.data.message);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      const handleDelete = async (blog) => {
            const response = await axios
                  .delete(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/departing_cities/${blog.slug}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setCities((categories) =>
                                    categories.filter(
                                          (item) => item.id !== blog.id
                                    )
                              );
                              loadData();
                              toast.success(response.data.message);
                              return true;
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            return response;
      };

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Departing City List">
                                          <LinkButton
                                                link="/dashboard/departing_cities/create"
                                                title="Add New"
                                          />
                                          <LinkButton
                                                link="/dashboard/departing_cities/manage/order"
                                                title="Manage Order"
                                          />
                                    </CardHeader>
                                    <CardBody
                                          setLimit={setLimit}
                                          perPages={perPages}
                                          totalItems={totalCities}
                                          currentPage={currentPage}
                                          getData={getData}
                                          setSearch={setSearch}
                                    >
                                          <table className="table table-bordered table-hover">
                                                <thead>
                                                      <tr>
                                                            <th>#</th>
                                                            <th>Title</th>
                                                            <th width="160px">
                                                                  Featured
                                                            </th>
                                                            <th width="100px">
                                                                  Status
                                                            </th>
                                                            <th width="120px">
                                                                  Action
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {!loading ? (
                                                            cities?.length >
                                                            0 ? (
                                                                  cities?.map(
                                                                        (
                                                                              blog,
                                                                              index
                                                                        ) => (
                                                                              <>
                                                                                    <tr
                                                                                          key={
                                                                                                index
                                                                                          }
                                                                                    >
                                                                                          <td>
                                                                                                {
                                                                                                      ++index
                                                                                                }
                                                                                          </td>
                                                                                          <td>
                                                                                                <ProductImage
                                                                                                      title={
                                                                                                            blog.title
                                                                                                      }
                                                                                                      category={`On: ${blog.date}`}
                                                                                                />
                                                                                          </td>
                                                                                          <td>
                                                                                                <Form.Check
                                                                                                      type="switch"
                                                                                                      id="custom-switch"
                                                                                                      defaultChecked={
                                                                                                            blog.featured ===
                                                                                                            1
                                                                                                                  ? true
                                                                                                                  : false
                                                                                                      }
                                                                                                      onClick={() =>
                                                                                                            handleFeatured(
                                                                                                                  blog
                                                                                                            )
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                          <td>
                                                                                                <Form.Check
                                                                                                      type="switch"
                                                                                                      id="custom-switch"
                                                                                                      defaultChecked={
                                                                                                            blog.status ===
                                                                                                            1
                                                                                                                  ? true
                                                                                                                  : false
                                                                                                      }
                                                                                                      onClick={() =>
                                                                                                            handleStatus(
                                                                                                                  blog
                                                                                                            )
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                          <td className="text-center">
                                                                                                <EditButton
                                                                                                      link={`/dashboard/departing_cities/${blog.slug}/edit`}
                                                                                                />
                                                                                                <ViewButton
                                                                                                      link={`/dashboard/departing_cities/${blog.slug}/show`}
                                                                                                />
                                                                                                <DeleteButton
                                                                                                      item={
                                                                                                            blog
                                                                                                      }
                                                                                                      loading={
                                                                                                            loading
                                                                                                      }
                                                                                                      setLoading={
                                                                                                            setLoading
                                                                                                      }
                                                                                                      handleDelete={
                                                                                                            handleDelete
                                                                                                      }
                                                                                                />
                                                                                          </td>
                                                                                    </tr>
                                                                              </>
                                                                        )
                                                                  )
                                                            ) : (
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    5
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              No
                                                                              Departing
                                                                              City
                                                                              Found
                                                                        </td>
                                                                  </tr>
                                                            )
                                                      ) : (
                                                            <>
                                                                  <tr>
                                                                        <td
                                                                              colSpan={
                                                                                    6
                                                                              }
                                                                              className="text-center"
                                                                        >
                                                                              Loading...
                                                                        </td>
                                                                  </tr>
                                                            </>
                                                      )}
                                                </tbody>
                                          </table>
                                    </CardBody>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default DepartingCityList;
